import { getSubscriptionStatus } from '@debbie/common/dist/cosmoV2/utils/providers.js';
import { Gender } from '@debbie/common/dist/index.js';
import { useCosmoV2ProviderSubscriptions } from '@debbie/cortex/dist/cosmoV2/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../theme.js';
import Badge from '../Badge.js';
import FormatJSON from '../FormatJSON.js';
import Globe from '../Icons/Globe.js';
import User from '../Icons/User.js';
import { Modal } from '../index.js';
import UserDeliverability from './UserDeliverability.js';
const UserInfoHeader = (props) => {
    const lang = useSelector((s) => s.lang);
    const loader = useCosmoV2ProviderSubscriptions(props.user.userId);
    const providerSubscriptions = h.hasData(loader)
        ? getSubscriptionStatus(loader.data)
        : null;
    const [openModal, setOpenModal] = useState(false);
    const [rawAks, setRawAks] = useState(null);
    const { customer, user } = props;
    const isAksEnrolled = !!providerSubscriptions &&
        !!providerSubscriptions.AKS?.sub &&
        !providerSubscriptions.AKS.sub.unsubscribedAt;
    const aksError = providerSubscriptions?.AKS?.sub.error;
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null,
            user.relation !== 'alternative-contact' && (React.createElement("span", null, customer.isCompany ? (React.createElement(React.Fragment, null,
                React.createElement(Globe, null),
                " ",
                lang.debtorInfo.company)) : (React.createElement(React.Fragment, null,
                React.createElement(User, null),
                ' ',
                Gender.MALE === user.details.gender
                    ? `${lang.debtorInfo.male}`
                    : Gender.FEMALE === user.details.gender
                        ? `${lang.debtorInfo.female}`
                        : `${lang.debtorInfo.private}`)))),
            isAksEnrolled && (React.createElement("div", { style: { margin: `${THEME.GRID_SPACING}px 0` } },
                React.createElement(Badge, { theme: THEME.SUCCESS },
                    "Experian AKS ",
                    lang.debtorInfo.subscribed))),
            aksError && (React.createElement("div", { style: {
                    margin: `${THEME.GRID_SPACING}px 0`,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                } },
                React.createElement(Badge, { theme: THEME.DANGEROUS },
                    "Experian AKS ",
                    lang.debtorInfo.failed,
                    ": ",
                    aksError))),
            user.details.addressProtection && (React.createElement("div", { style: { margin: `${THEME.GRID_SPACING}px 0` } },
                React.createElement(Badge, { theme: THEME.DANGEROUS }, lang.debtorInfo.addressProtection))),
            React.createElement(UserDeliverability, { details: user.details })),
        openModal && (React.createElement(Modal, { onToggle: () => setOpenModal(!openModal) }, rawAks && React.createElement(FormatJSON, { json: rawAks })))));
};
export default UserInfoHeader;
//# sourceMappingURL=UserInfoHeader.js.map